import { ShiftType } from "../hooks";
import { DataListType } from "../types";

export function formatForm(data: DataListType[], shift?: ShiftType[], shift_schedule_id?: string) {
    return data.map(item => ({
        employee_id: String(item.employee_id ?? ""),
        location_id: String(item.location_id ?? ""),
        divisi_id: String(item.divisi_id ?? ""),
        department_id: String(item.department_id ?? ""),
        job_position_id: String(item.job_position_id ?? ""),
        shift_schedule_id: String(shift_schedule_id ?? ""),
        shift_schedule: item.shift_schedule.map(s => {
            const info = shift?.find(v => v.value === s.mr_shift_id?.toString());
            return ({
                shift_date: s.shift_date,
                shift_schedule_detail_id: s.shift_schedule_detail_id?.toString() ?? null,
                mr_shift_id: s.mr_shift_id?.toString() ?? null,
                checked: Boolean(s.mr_shift_id),
                shift_schedule_id: String(shift_schedule_id ?? ""),
                in_time: info?.in_time,
                out_time: info?.out_time
            });
        })
    }));
}
